<template>
  <div id="header-container">
    <div class="system">
      <img src="../../../public/image/logo.png" align="absmiddle" @click="setThumb"
           :title="thumb === 1 ? '展开菜单栏' : '折叠菜单栏'"/>
      {{config.systemName}}
    </div>
    <div class="toolbar">
      <span style="padding-right:20px;" v-if="loginShop?.shop_name">{{loginShop.shop_name}}（{{loginShop.shop_extname}}）</span>
      <img src="../../../public/image/avatar.png" style="width: 25px; height: 25px;"  align="absmiddle"/>
      &nbsp;{{user_name}}
      &nbsp;&nbsp;&nbsp;<img src="../../../public/image/header_line.png" align="absmiddle"/>
      &nbsp;&nbsp;&nbsp;岗位&nbsp;
      <select v-model="officer_id">
        <template v-for="item in officerList">
          <option :key="item.officer_id" :value="item.officer_id">
            {{item.officer_name}}
          </option>
        </template>
      </select>&nbsp;&nbsp;
      &nbsp;&nbsp;<img src="../../../public/image/home.png" align="absmiddle" title="首页"/>
      &nbsp;&nbsp;<img src="../../../public/image/password.png" align="absmiddle" title="修改密码" @click="dialog=true"/>
      &nbsp;&nbsp;<img src="../../../public/image/exit.png" title="退出" align="absmiddle" @click="logout"/>
    </div>
    <div class="clear"></div>
    <password-edit :show="dialog" @close="close"/>
  </div>
</template>

<script>
import * as config from '../../core/config'
import * as selfApi from '../../api/self'
import PasswordEdit from '@/component/dialog/self/PasswordEdit'

export default {
  name: 'NavHeader',
  components: {
    'password-edit': PasswordEdit
  },
  data () {
    return {
      config: config,
      dialog: false
    }
  },
  computed: {
    thumb: function () {
      return this.$store.state.session.thumb
    },
    user_name: function () {
      return this.$store.state.self.info != null ? this.$store.state.self.info.user_name : ''
    },
    officer_id: {
      get () {
        return this.$store.state.self.info != null ? this.$store.state.self.info.officer_id : ''
      },
      set (nv) {
        this.changeOfficer(nv)
      }
    },
    officerList: function () {
      return this.$store.state.self.officerList
    },
    loginShop: function () {
      return this.$store.state.self.loginShop
    },
  },
  methods: {
    setThumb () {
      this.$store.dispatch('setSessionThumb', (this.$store.state.session.thumb === 1 ? 0 : 1))
    },
    logout () {
      if (confirm('确认退出?')) {
        this.$store.dispatch('logout').then(() => {
          location.reload()
        })
      }
    },
    changeOfficer (officer_id) {
      const lock = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading'
      })
      const param = {
        officer_id: officer_id
      }
      selfApi.changeOfficer(param).then(rr => {
        // location.reload会自动关闭lock
        // lock.close()
        config.setAccessToken(rr.data.access_token)
        setTimeout(function () {
          location.reload()
        }, 1000)
      }).catch(rr => {
        lock.close()
        this.$base.failure(this, rr)
      })
    },
    close () {
      this.dialog = false
    }
  }
}
</script>
